export default {
  actions: 'Actions',
  downloadDocument: 'Download document',
  downloadContact: 'Download person',
  addNewInformation: 'Enter new information',
  addInputsAdditional: 'Add additional field',
  peopleOf: 'people of',
  businessOf: 'companies of',
  previous: 'Back',
  oneTimePassword: 'One time password',
  changePassword: 'Change password',
  deletePerson: 'Delete person',
  assignResponsible: 'Assign owner',
  activeSince: 'Active since',
  next: 'Next',
  personlizeFields: 'Custom fields',
  personlizedFields: 'Custom fields',
  createPerson: 'Create person',
  youreAboutToDeleteTheSelectedPersons: 'You´re about to delete the selected people',
  opportunities: 'Opportunities',
  imported: 'Imported',
  notImported: 'Not importaded',
  acceptedData: 'Accepted data',
  rejectedData: 'Rejected data',
  deactivatedPerson: 'Deactivated person',
  whatsApp: 'WhatsApp',
  form: 'Form',
  web: 'Web',
  facebook: 'Facebook',
  instagram: 'Instagram',
  selectJourneyState: 'Select the status to be assigned',
  title: 'Title',
  addTaskTitle: 'Enter task title',
  observations: 'Observations',
  addObservations: 'Enter observations',
  dueDate: 'Due date',
  addDueDate: 'Enter due date',
  assignResponsibleToThisUsers: 'Assign an owner for this person',
  addResponsible: 'Enter owner',
  createTask: 'Create task',
  and: 'and',
  morePerson: 'more people',
  morePeople: 'more people',
  youreAboutToChangeThePasswordOf: 'You´re about to change the password of ',
  rememberToInformThemAboutTheNewPassword: ', remember to inform the user about the change',
  createNewPerson: 'Create a new person',
  idType: 'Identification type',
  idNumber: 'Identification number',
  passport: 'Passport',
  citizenCard: 'Citizen Card',
  idCard: 'ID card',
  selectResponsibleFor: 'Select an owner for ',
  selectAResponsible: 'Select an owner',
  responsibleAdded: 'Owner added',
  generatedPasswordCanBeUsedOneTime: 'The generated password can only be used once',
  generatePassword: 'Generate password',
  passwordCopied: 'Password copied to clipboard',
  importerStepOne: 'Step 1: Select if you want to save the imported people to a segment',
  existentSegment: 'Existent segment',
  newSegment: 'New segment',
  noSegment: 'No segment',
  selectASegment: 'Select a segment',
  writeTheSegmentName: 'Write the segment`s name',
  importerStepTwo: 'Step 2: Upload the file where you have your contacts in an Excel or CSV format',
  selectFile: 'Select the file',
  fileTypeWarning: 'It´s important that the file is a .xlsx extension to use special characters',
  goBack: 'Go back',
  importerStepThree: 'Step 3: Identify each field according to the information it will contain',
  identifyFields: 'Identify each field according to the information it will contain',
  impoterStepFour: 'Step 4: Data',
  existentUsersOperation: 'Existent people operation',
  referenceCountry: 'Reference country',
  verifyTheInformationIsCorrect: 'Verify the information is correct before continue',
  importerStepFive: 'Step 5: Select an owner for the new people in your CRM',
  newColumnName: 'New column name',
  fieldName: 'Field name',
  personlInformationItems: 'Personal information fields',
  businessInformationItems: 'Business information fields',
  extraDataItems: 'Custom fields',
  update: 'Update',
  ignore: 'Ignore',
  youreAboutToDeleteTheSelectedPerson: 'You´re about to delete the selected person',
  areYouSure: 'Are you sure?',
  userDeleted: 'Person deleted',
  loading: 'Loading',
  selectedUsers: 'Selected people',
  selectedBusinesses: 'Selected businesses',
  selectedBusiness: 'Selected business',
  habeasData: 'Data protection',
  createSegment: 'Create segment',
  addToSegment: 'Add to a segment',
  registerType: 'Register type',
  selectResponsible: 'Select an owner',
  personsImportedSuccessfully: 'People imported, it might take a while for them to be visible in your CRM',
  errorImporting: 'Error importing people',
  addName: 'Enter name',
  addLastName: 'Enter lastname',
  addEmail: 'Enter email',
  addIdType: 'Enter identification type',
  addIdNumber: 'Enter identification number',
  addRol: 'Enter rol',
  youMustEnterATaskTitle: 'You must enter a title for the task',
  youMustEnterDateAndTime: 'You must enter Date and Time',
  youMustEnterAName: 'You must enter a name for the person',
  youMustEnterAPhoneNumberOrEmail: 'You must enter a phone number or email for the person',
  youMustEnterAValidEmail: 'You must enter a valid email',
  noSegmentsFoundForUser: 'No segments found for this person.',
  enterTaskNameAndObservations: 'Enter name and observations for the task',
  enterADueDate: 'Select a due date',
  enterADueTime: 'Select a termination time',
  enterANewTask: 'Enter a new task',
  typeOfTask: 'Type of task',
  toDoTasks: 'To do tasks',
  deleteTask: 'Delete task',
  moveToFinishedTasks: 'Move to finished tasks',
  finishedTasks: 'Finished tasks',
  moveToTodoTasks: 'Move to to do tasks',
  couldntFindTasksForThisUser: 'No tasks found for this user',
  currentJourney: 'Current Status',
  removeJourney: 'Delete Status',
  selectABusiness: 'Select a compamy',
  loadingMoreBusinesses: 'Loading more companies',
  enterThePersonsPosition: 'Enter the persons tittle',
  newBusiness: 'New company',
  addPerson: 'Add person',
  url: 'URL',
  couldntFindBusinessesForThisUser: 'No companies found for this person.',
  businessUrl: 'Company website',
  addPicture: 'add picture',
  addBusiness: 'Add company',
  code: 'Code',
  segment: 'Segment',
  youreAboutToDeleteTheSelectedDocument: 'You´re about to delete the selected document',
  documentDeleted: 'Document deleted',
  addADescriptionForTheDocument: 'Add a description for the document',
  addDescription: 'Enter description',
  editDocument: 'Edit document',
  deleteDocument: 'Delete document',
  couldntFindDocumentsForThisUser: 'No documents found for this person.',
  aDocumentWithThisNameAlreadyExists: 'A document with this name already exists',
  fileMustBeLighterThan10MB: 'The file must be lighter than 10MB',
  loadingMoreResponsibles: 'Loading more owners',
  youreAboutToDeleteTheSelectedNote: 'You´re about to delete the selected note',
  noteDeleted: 'Note deleted',
  addNote: 'Add note',
  couldntFindNotesForThisUser: 'No notes found fot this person',
  theNoteIsEmpty: 'The note is empty',
  couldntFindLogsForThisUser: 'No logs found for this person.',
  createFlow: 'Create flow',
  flowType: 'Flow type',
  didntFindFlowTypes: 'Didnt find flow types',
  didntFindFlows: 'Didnt find flows',
  didntFindFlowSteps: 'Didnt find steps for this flow flow',
  youMustSelectAFlow: 'Must select a flow',
  flow: 'Flow',
  step: 'Step',
  priority: 'Priority',
  amount: 'Amount',
  business: 'Company',
  loadingMorePersons: 'Loading more people',
  couldntFindOpportunitiesForThisPerson: 'No opportunities found for this person.',
  couldntFindOpportunitiesForThisBusiness: 'No opportunities found for this company.',
  high: 'High',
  regular: 'Regular',
  low: 'Low',
  none: 'None',
  flowCreated: 'Flow crearted',
  errorFlowCreated: 'Error creating opportunity',
  youreAboutToDeleteTheSelectedSegment: 'You´re about to delete the selected segment',
  segmentDeleted: 'Segment deleted',
  editSegment: 'Edit segment',
  deleteSegment: 'Delete segment',
  segmentsOf: 'segments of',
  segmentType: 'Type of segment',
  numberOfPeople: 'Number of people',
  dynamic: 'Dynamic',
  static: 'Static',
  youreAboutToDeleteTheSelectedUser: 'You´re about to delete the selected person',
  id: 'ID',
  segmentUpdated: 'Segment updated',
  addToExistentSegment: 'Add to an existent segment',
  selectSegment: 'Select segment',
  thereWillBeAdded: 'There will be added',
  personsToThisList: 'persons to this segment',
  createNewSegment: 'Create new segment',
  segmentName: 'Name of the segment',
  assignANameToTheSegment: 'Add a name for the segment',
  youreAboutToDeleteTheSelectedBusiness: 'You´re about to delete the selected company',
  youreAboutToDeleteTheSelectedBusinesses: 'You are about to delete the selected companies',
  businessDeleted: 'Company deleted',
  editBusiness: 'Edit company',
  deleteBusiness: 'Delete company',
  removeBusiness: 'Remove from company',
  businessesOf: 'Companies of',
  status: 'Status',
  businessPhone: 'Company Phone Number',
  addExtradata: 'Add a custom field',
  enterExtradataName: 'Type a name for the custom field',
  enterExtradataValues: 'Type a value for this field',
  image: 'Image',
  addImage: 'Enter image',
  businessEdited: 'Company edited',
  errorEditing: 'There was an error editing',
  businessInformation: 'Company information',
  addContact: 'Add person',
  position: 'Position',
  addNewContact: 'Add new person',
  addNewRol: 'Add new rol',
  addRoles: 'Add roles',
  enterFullName: 'Add full name',
  enterEmail: 'Enter email',
  createNewBusiness: 'Create new company',
  createBusiness: 'Create company',
  businessCreated: 'Business created',
  errorCreatingBusinessErrorFields: 'Incomplete fields, please check',
  errorCreatingBusiness: 'There was an error creating the company',
  addCode: 'Enter code',
  addUrl: 'Enter url',
  addCategories: 'Enter categories',
  youreAboutToArchiveTheSelectedForm: 'Youre about to archive the selected form',
  afterArchiving: 'After archiving you can only see it in the archives forms list',
  seeAnswers: 'See replies',
  formsOf: 'forms of',
  answers: 'Replies',
  newForm: 'New form',
  answersAmount: 'Amount of replies',
  editStyle: 'Edit style',
  saveAndShare: 'Save and share',
  enterFormName: 'Enter form name',
  enterFormDescription: 'Enter form description',
  youMustEnterANameForTheForm: 'You must add a name for the form',
  formSaved: 'Form saved',
  errorSavingForm: 'Error creating form',
  option: 'Option',
  fileAmount: 'File amount',
  termsAndConditions: 'Terms and conditions',
  editTermsAndConditionsLink: 'Edit terms and conditions link',
  required: 'Required',
  duplicate: 'duplicate',
  shortAnswer: 'Short answer',
  longAnswer: 'Long answer',
  radialButtons: 'Radial buttons',
  checkboxes: 'Checkboxes',
  fileUpload: 'File upload',
  selectList: 'Select list',
  characters: 'Characters',
  hiddenField: 'Hidden Field',
  fieldType: 'Field type',
  general: 'General',
  uploadImage: 'Upload image',
  themeColor: 'Theme color',
  backgroundColor: 'Background color',
  fontType: 'Font type',
  fontColor: 'Font color',
  fontSize: 'Font size',
  inputs: 'Fields',
  inputType: 'Field type',
  flat: 'Flat',
  normal: 'Normal',
  rounded: 'Rounded',
  line: 'Line',
  fill: 'Fill',
  inputColor: 'Field color',
  submitButton: 'Send button',
  buttonType: 'Button type',
  textColor: 'Text color',
  buttonAlignment: 'Button alignment',
  visualization: 'Visualization',
  visualizationType: 'Visualization TYPE',
  survey: 'survey',
  contact: 'Contact',
  notification: 'Notification',
  emailOrPhoneToNotifyFormSend: 'Email or phone to notify form reply',
  sendEmail: 'Send email',
  sendSms: 'Send SMS',
  emailSubject: 'Email subject',
  message: 'Message',
  optionDeactivatedTemporarilly: 'Option deactivated temporarilly',
  stepOneShareForm: 'Step 1: Add the following code to your page',
  stepOneShareFormSec: '',
  stepTwoShareForm: 'Step 2: Add the following Script to your page',
  stepTwoShareFormSec: '',
  codeCoppied: 'Code copied',
  share: 'Share',
  insertForm: 'Insert form',
  errorRecieved: 'Error recieved',
  importInformation: 'import information',
  numberOfRows: 'Number of rows',
  totalRecords: 'Total records',
  uniqueRecords: 'Unique records',
  updatedRecords: 'Updated records',
  insertedRecords: 'New records',
  duplicatedRecords: 'Duplicated records',
  headers: 'Headers',
  file: 'file',
  downloadOriginal: 'Download original',
  downloadNewRecords: 'Download new registers',
  downloadUpdatedRecords: 'Download updated records',
  downloadWrongRecords: 'Download inconsistent records',
  importsOf: 'imports of',
  fileSize: 'File size',
  progress: 'Progress',
  started: 'Started',
  finished: 'Finished',
  error: 'Error',
  inProgress: 'In progress',
  nameAndLastName: 'Name and lastname',
  register: 'Register',
  attachOnWebsite: 'Attach on website',
  data: 'Data',
  identification: 'Identification',
  stateDepartment: 'State/Departament',
  city: 'City',
  bloodType: 'Blood type',
  personlization: 'Personlization',
  personlizedPhrase: 'Personlized phrase',
  loginpersonlizedPhrase: 'Login personlized phrase',
  signuppersonlizedPhrase: 'Signup personlized phrase',
  registerMode: 'Register mode',
  accessButtonPhrase: 'Access button ersonlized phrase',
  registerButtonPhrase: 'Register button personlized phrase',
  hideSocialMedia: 'Hide social media',
  showRegisterFirst: 'Show registration first',
  showpersonlizedButton: 'Show personalized button',
  buttonText: 'Button text',
  redirectUrl: 'Redirect Url',
  emailCellphone: 'Email/Cellphone',
  imageUpdated: 'Image Updated',
  authenticatorUpdated: 'Autenticator Updated',
  authShareStepOne: 'Step 1: Create a',
  authShareStepOneSec: 'element with the ID',
  authShareStepOneTh: 'in your page',
  authShareStepOneFo: '',
  authShareStepTwo: 'Step 2: Add the following Script to your page',
  authShareStepTwoSec: 'd',
  authShareExtraStep: 'To add DOM elements that allow  KeybeUI to open, you can use a Script similar to this one',
  selectImage: 'Select image',
  whatHappensAfterSend: 'What would you like to show after form send?',
  formSend: 'Form sent',
  youWillRecieveAnEmailWithTheDownloadLink: 'You will recieve an email with the download link',
  openConversationsHistory: 'Open conversations history',
  showUnarchivedFiles: 'Show unarchived filed',
  showArchivedFiles: 'Show archived files',
  onlyValidForColombia: 'Only available in Colombia',
  aditionalFields: 'Aditional fields',
  successAddFields: 'It was updated successfully',
  tags: 'Tags',
  createCampaign: 'Create campaign',
  expand: 'Expand',
  collapse: 'Collapse',
  noDataFound: 'No data found',
  showSuccessMessage: 'Show success message',
  enterRedirectUrl: 'Enter URL to redirect',
  redirectToANewPage: 'Redirect to a new page',
  registerUserForm: 'Register users form',
  registerName: 'Register name',
  registerPhone: 'Register phone',
  registerEmail: 'Register email',
  youMustSelectARegisterField: 'You must select at least a register email or phone',
  formType: 'Form type',
  moreOpportunitiesForYourBusiness: 'More opportunities for your business',
  moreTicketsForYourBusiness: 'More support tickets for your business',
  noOpportunitiesCreated: 'No opportunities created',
  createAndPersonalizeYourOwnOpportunityFlows: 'Create and personalize your own opportunity flows',
  createAndPersonalizeYourOwnTicketFlows: 'Create and personalize your own support ticket flows',
  addTheNewFlowName: 'Add new flow name',
  seeAllFlows: 'See all flows',
  createTicket: 'Create ticket',
  selectAPipeline: 'Select a flow',
  createPipeline: 'Create flow',
  amountOnThisStep: 'Accumulated on this step',
  highPriority: 'High',
  mediumPriority: 'Medium',
  lowPriority: 'Low',
  createOpportunity: 'Create opportunity',
  addPeople: 'Add people',
  createAStep: 'Create step',
  winProbability: 'Win probability',
  mustCompleteAllFields: 'You must complete all fields',
  adminCreated: 'Admin was created successfully',
  youllRevieceAnEmailWithTheExport: 'All done! You´ll recieve an email with the download link',
  other: 'Others',
  pipelineCreatedSuccessfully: 'Flow created successfully',
  errorCreatingPipeline: 'Error creating flow',
  mustSelectUsersOrBussiness: 'You must select a company or person for this opportunity',
  opportunityCreatedSuccessfully: 'Opportunity created successfully',
  ticketCreatedSuccessfully: 'Ticket created successfully',
  couldntCreateOpportunity: 'Couldn´t create opportunity',
  selectAProbabilityOrWriteACustomOne: 'Select a probability or write a custom one',
  youreNotTheResponsible: 'You´re not the owner of this opportunity',
  editStep: 'Edit step',
  pipelineUpdatedSuccessfully: 'Flow edited successfully',
  errorUpdatingPipeline: 'Error updating flow',
  editPipeline: 'Edit flow',
  pipelineType: 'Flow type',
  support: 'Support',
  stepCreatedSuccessfully: 'Step created successfully',
  dependent: 'Dependent',
  dependsOn: 'Field that depends on',
  dependency: 'Dependency',
  dependencies: 'Dependencies',
  helpTextExcelDependent: 'You can copy the options from an excel file. It must have the distribution shown in the picture.',
  help: 'Help',
  label: 'Label',
  you: 'You',
  noBusiness: 'No brand',
  editOpportunity: 'Edit opportunity',
  deleteOpportunity: 'Delete opportunity',
  youreAboutToDeleteTheSelectedOpportunity: 'You´re about to delete the selected opportunity',
  opportunityDeleted: 'Opportunity deleted',
  deleteStep: 'Delete step',
  youreAboutToDeleteTheSelectedStep: 'You´re about to delete the selected step',
  stepDeleted: 'Step deleted',
  deletePipeline: 'Delete flow',
  youreAboutToDeleteTheSelectedPipeline: 'You´re about to delete the selected flow',
  pipelineDeleted: 'Flow deleted',
  aPipelineWithThatNameAlreadyExists: 'A flow with that name already exists',
  noPeople: 'No people',
  agreements: 'Agreements',
  document: 'Document',
  observation: 'Observation',
  segmentOrganizeSend: 'Segment, organize and send!',
  segmentsSubtitle: 'Your people in segments to communicate easier and faster',
  allPeople: 'All people',
  totalPersons: 'Total people',
  see: 'See',
  seeList: 'See segment',
  seeAllPeopleList: 'See all people',
  sendMessage: 'Send message',
  importSegment: 'Import segment',
  allBusinesses: 'All brands',
  conversationHistory: 'Conversation history',
  principalData: 'Principal data',
  addNewNote: 'Add new note...',
  peopleFilters: 'People filters',
  businessFilters: 'Companies filters',
  youreInMobile: 'You are viewing our mobile version, for a better experience please download our app',
  hereYouCanFindAllBusinesses: 'Here you can find all the companies your´re  in contact with',
  associatedPeople: 'Associated people',
  personsEditedCorrectly: 'People edited successfully',
  youreAboutToDeleteTheSelectedJourney: 'You´re about to delete the selected status',
  journeyDeleted: 'Status deleted',
  addNewJourney: 'Add new status',
  dependencyOf: 'Dependency of',
  options: 'Options',
  youreAboutToDeletedTheSelectedData: 'You´re about to delete the selected data',
  dataDeleted: 'Data deleted',
  selectDependencies: 'Select dependencies',
  selectJourneyColor: 'Select the status color',
  color: 'Color',
  journeyByDefault: 'Do you want this to the the default status when people register?',
  journeyLateralMenu: 'Do you want to show the status on the lateral menu?',
  mustAddANameToTheJourney: 'You must add a name to the journey',
  addARol: 'Add a rol',
  selectARol: 'Select a rol',
  extradata: 'Extra data',
  editInBlock: 'Edit in bulk',
  passwordUpdatedSuccessfully: 'Password updated successfully',
  phoneNumberInvalid: 'Phone number invalid',
  errorCreatingAdmin: 'Error creating admin',
  adminUpdated: 'Admin updated',
  errorUpdatingAdmin: 'Error updating admin',
  unauthorized: 'You´re not authorized for this action',
  appNotFound: 'Error, app not found',
  userExistsAlready: 'This email or phone number is already beign used by another person',
  unexpectedError: 'Unexpected error',
  credentialError: 'the credentials do not match',
  appInactive: 'Access Denied, You Don’t Have Permission the APP is Inactive',
  pass_isempty: 'Please enter a password',
  userInactive: 'The email you entered is inactive or does not exist, please validate your credentials',
  optionAlreadyExists: 'An option with this name already exists',
  followUpWithYourClients: 'Follow up with your clients',
  createYourFlows: 'Create and manage your own opportunity flows',
  markAsDone: 'Mark as done',
  markAsToDo: 'Mark as to do',
  configTaskTypes: 'Config task types',
  editTicket: 'Edit ticket',
  personalizedFields: 'Personalized fields',
  example: 'Example',
  personalizeFields: 'Personalize fields',
  personalInformationItems: 'Personal information fields',
  businessesImportedSuccessfully: 'Companies imported correctly, it might take a while to show on the list',
  flows: 'Flows',
  personalization: 'Customization',
  personalizedPhrase: 'Custom phrase',
  loginPersonalizedPhrase: 'Login custom phrase',
  signupPersonalizedPhrase: 'Signin custom phrase',
  showPersonalizedButton: 'Show custom button',
  whatDoYouWantThisFlowToDo: 'What do you want this flow to do?',
  sales: 'Sales',
  salesAndTickets: 'Sales and tickets',
  customerService: 'Customer service',
  stepUpdatedSuccessfully: 'Step edited corectly',
  errorUpdatingStep: 'Error editing step',
  couldntCreateOpportunit: 'Error creating opportunity',
  opportunityEdited: 'Opportunity edited correctly',
  youCanOnlyAddPeople: 'You can only add people, not delete them',
  writeYourPassword: 'Write your password',
  mustAddCompanyName: 'Must add company name',
  mustAddName: 'Must add name',
  registerFormExplanation: 'Register forms must have any of the registration fields (Register name, register email or register phone)',
  activities: 'Activities',
  activity: 'activity',
  couldntFindActivitiesForThisUser: 'No activity found for this person',
  couldntFindActivitiesForThisOpportunity: 'No activity found for this opportunity',
  couldntFindActivitiesForThisBusiness: 'No activity found for this company',
  somethingUnexpectedHappenedTryAgain: 'Something unexpected happened, please try again later',
  registerMail: 'Register email',
  registerCall: 'Register call',
  registerMeeting: 'Register meeting',
  createActivity: 'Create activity',
  registerWhatsApp: 'Register WhatsApp',
  result: 'Result',
  activityAddedSuccessfully: 'Activity added successfully',
  theFieldIsRequired: 'The field ### is required',
  today: 'Today',
  hour: 'Hour',
  noresults: 'No results',
  call: 'Call',
  email: 'Email',
  whatsapp: 'WhatsApp',
  sms: 'SMS',
  meeting: 'Meeting',
  doesNotAnswer: 'Does not answer',
  voicemail: 'Voicemail',
  occupied: 'Busy',
  receptionist: 'Gatekeeper',
  wrongNumber: 'Wrong number',
  numberWithoutService: 'Number disconnected',
  connectedPositive: 'Connected - Positive',
  connectedNeutral: 'Connected - Neutral',
  connectedNegative: 'Connected - Negative',
  delivered: 'Delivered',
  open: 'Open',
  answered: 'Answered',
  rebound: 'Bounced',
  click: 'Click',
  deregistered: 'Deregistered',
  notSent: 'Not sent',
  completed: 'Completed',
  rescheduled: 'Rescheduled',
  didNotAssist: 'Did not assist',
  cancelled: 'Cancelled',
  loggedEmailBy: 'Logged email by',
  loggedMeetingBy: 'Logged meeting by',
  callFrom: 'Call from',
  loggedCallBy: 'Logged call by',
  loggedOtherBy: 'Logged activity by',
  unknown: 'Unknown',
  youreAboutToDeleteTheSelectedActivity: 'You´re about to delete the selected activity',
  activityDeleted: 'Deleted activity',
  direction: 'Direction',
  inbound: 'Inbound',
  outbound: 'Outbound',
  duration: 'Duration',
  minutes: 'Minutes',
  hours: 'Hours',
  lostReason: 'Lost reason',
  datesRanges: 'Date ranges',
  conversationCloseAt: 'Date of conversation ending',
  conversationCreatedAt: 'Date of conversation creation',
  conversationUpdateAt: 'Date of conversation update',
  api: 'API',
  chatWeb: 'Web Chat',
  personAddedToSegment: 'Person added to segment',
  personCreated: 'Person created',
  errorGettingPipelines: 'Error getting opportunities',
  errorGettingSteps: 'Error getting steps',
  errorGettingPipeline: 'Error getting pipeline',
  seeMore: 'See more',
  source: 'Source',
  feeling: 'Emotion',
  associatePeople: 'Associate a person',
  associateABusiness: 'Associate a company',
  ecommerce: 'E-commerce',
  physicalStore: 'Physical store',
  angry: 'Angry',
  dissapointed: 'Dissapointed',
  neutral: 'Neutral',
  satisfied: 'Satisfied',
  verySatisfied: 'Very satisfied',
  opportunityAmount: '$ Opportunity amount',
  mostPeopleFeel: 'Most people feel',
  stepName: 'Step name',
  salesText: '😎 Sales? ...That´s my first name',
  seeFlow: 'See flow',
  editFlow: 'Edit flow',
  createNewFlow: 'Create a new opportunities flow',
  flowName: 'Flow name',
  noStepsYet: 'Seems there are no steps for this flow',
  associateAProduct: 'Associate a product',
  interested: 'Interested',
  inProcess: 'In process',
  pending: 'Pending',
  won: 'Won',
  lost: 'Lost',
  wereGettingEverythingReady: 'Wait a few seconds while we get everything ready...',
  salesPipeline: 'Sales',
  requirement: 'Requirement',
  study: 'Study',
  response: 'Response',
  seeLess: 'See less',
  seeAll: 'See all',
  steps: 'Stages',
  totalAmount: 'Total amount',
  maxTimeInStep: 'Maximum time of an opportunity in this step',
  maxTimeTooltip: 'Once the limit time of an opportunity reaches, it will turn red to alert you 🛑',
  amountWithProducts: 'Amount with products',
  sendCampaignButton: 'Send campaign',
  extradatas: 'Additional data',
  addDocument: 'Add document',
  journeyBusinessText1: 'There´s',
  journeyBusinessText2: 'contacts associated to this company',
  journeyBusinessText3: 'Do you want to update the state of all the associated contacts?',
  time: 'Time',
  byAmount: 'By amount',
  createdToday: 'Created today',
  createdLastWeek: 'Created last week',
  createdLastMonth: 'Created last month',
  noManagement: 'No management',
  opportunityFilters: 'Opportunity filters',
  ticketFilters: 'Ticket filters',
  selectAResponsibleFor: 'Select an owner for',
  yes: 'Yes',
  no: 'No',
  addBrandToBusiness: 'Add brand to company',
  associatedPerson: 'Associated person',
  associatedBusiness: 'Associated company',
  businessRoles: 'Role in company',
  newTask: 'New task',
  taskCreated: 'Task created',
  theInformationInTheFollowingFieldsHasBeenUpdated: 'The information in the following fields have been updated',
  updatingOfInformation: 'Updating of information',
  registerBy: 'Registered by',
  seeCampaign: 'See Campaign',
  heClosedAConversation: 'He closed a conversation',
  iTakeTheConversation: 'I take the conversation',
  campaignDelivery: 'Campaign delivery',
  receivedACampaign: 'Received a campaign',
  resumedTheConversation: 'Resumed the conversation',
  statusChange: 'Status change',
  statusIsUpdated: 'Status is updated',
  registerActivity: 'Register activity',
  activityRegister: 'Register',
  opportunity: 'Opportunity',
  ticket: 'Ticket',
  new: 'New',
  changeStep: 'step change',
  changed: 'changed',
  from: 'from',
  to: 'to',
  seeTicket: 'See Ticket',
  seeOpportunity: 'See Opportunity',
  in: 'in',
  stepMinus: 'step',
  name: 'name',
  lastName: 'last name',
  messageIssuedByTheAdvisor: 'Message issued by the user',
  heCreatedAConversation: 'Started a conversation',
  thePhoneIsAlreadyInUseForTheApp: 'The phone is already in use for the app',
  theEmailIsAlreadyInUseForTheApp: 'The email is already in use for the app',
  theSelectedResponsibleIsNotValid: 'The selected responsible is not valid',
  documentEditedSuccessfully: 'Document edited successfully',
  deletedDocument: 'Deleted document',
  errorUploadingDocument: 'Error uploading document',
  uploadSuccess: 'Upload success',
  success: 'Success',
  addedRole: 'Added Role',
  roleRemoved: 'Role removed',
  phone: 'phone',
  country: 'country',
  countryCode: 'country code',
  seeChat: 'See chat',
  stateless: 'stateless',
  identificationNumber: 'identification number',
  createOpportunityForUser: 'Create an opportunity related to this person',
  mustEnterALink: 'You must enter a url',
  mustEnterATextForLink: 'You must enter a text for the button',
  moveStep1: 'To move the opportunity to the step',
  moveStep2: 'you need a lost reason',
  price: 'Price',
  productNotAvailable: 'Product not available',
  noResponse: 'No response',
  reject: 'Reject',
  blacklist: 'Blacklist',
  Thereisalreadyaformwiththatname: 'There is already a form with that name',
  mustEnterAFormName: 'Oops! You must enter a form name',
  thisFieldsAreMandatory: 'This fields are mandatory to register a form type, you can change this on the edit style button',
  up: 'Move Up',
  down: 'Move down',
  valueToAppear: 'List value that\'ll show',
  fieldToAppear: 'Field that\'ll show',
  valueThatMakesAppear: 'Value that will make it show',
  dependentList: 'Dependent list',
  dependentField: 'Dependent field',
  dependentListExplanation: 'The dependent list will show or no elements on thisb list, depending on the selected element in a list type field previously created. You must enter the list elements and to their side the elements of the field that will make them show',
  rdText1: 'Looks like you\'re going to be a part of Keybe! The AI platform that helps you impluse your sales team performance. You will be able to chat with your clients and have predictive resplies automatically depending on the emotions that generate in every conversation',
  rdText2: 'Connect all your comunication channels in one and impluse your team with smart tips.',
  rdText3: 'You can start importing your information from RD Station',
  rdText4: 'We\'re importing your information from RD Station',
  rdText5: 'Remember that to send massive messages you must first:',
  connectsYourChannels: 'Connect your channels',
  connectWhatsappLine: 'Connect a WhatsApp line',
  okUnderstood: 'OK, I understand!',
  errorGettingStep: 'Didn\'t find opportunity step. It may have been deleted',
  yourDataIsDownloading: 'Your data is downloading!',
  letPeopleKnowYourDownloading: 'Let people know youre downloading their data',
  nextStepAfterVideo: 'We recomend that you watch this video that we prepared to explain more of the subject',
  videoStartsIn: 'Video starts in',
  noIUnderstood: 'No, I understood',
  yesIWillBeResponsible: 'Yes, I will handle it correctly',
  iConfirmIKnow: 'I confirm I\'m familiar with the',
  andICompromise: 'and I promise to handle the personal data in accordance with it',
  competition: 'Competition',
  aquashieldDeliveryTime: 'Aquashield delivery time',
  vehiclePendingForDeliveryByDealer: 'Vehicle pending for delivery from dealer',
  notInterested: 'Not interested',
  doesntHaveVehicle: 'Doesn\'t have vehicle',
  leadLackOfMaturityFromTheCompany: 'Leads / Lack of maturity from the company',
  leadNoResponse: 'Leads / No response',
  leadDigitalMarketing: 'Leads / Digital Marketing',
  leadpPersonalCourse: 'Leads / Personal Course',
  leadNoBudget: 'Leads / No budget',
  negociationNoResponse: 'Negociación / No response',
  negociationNoBudget: 'Negociación / No budget',
  negociationCompetition: 'Negociación / Competition',
  negociationConviction: 'Negociación / Convincing',
  negociationProspectForFuture: 'Negociación / Prospect for the future',
  quotaOnWallet: 'Quota on waller',
  deliveryTime: 'Delivery time',
  paymentMethodsFinancingSystem: 'Payment methods - Financing system',
  tooLongDeliveryTime: 'Product delivery time too long',
  highPrice: 'High price',
  purchaseAmountNotEnoughForDelivery: 'Purchase amount not enought for product delivery',
  ifYouCloseVideoStartOver: 'If you close the video you will have to start over',
  noDefaultSalePipelineStep: 'No default sale step defined',
  noDefaultTicketPipelineStep: 'No default ticket step defined',
  noDefaultSalePipeline: 'No default sale pipeline defined',
  noDefaultTicketPipeline: 'No default ticket pipeline defined',
  areYouSureYouWantToMoveTheOpportunity: 'Are you sure you want to move the opportunity',
  fromStep: 'from',
  toStep: 'to',
  noGoBack: 'No, go back',
  yesMove: 'Yes, I\'m sure',
  errorDialogActivity: 'The file or information you are trying to attach is too big',
  airCall: 'Aircall',
  airCallBody: 'Recieved a call through Aircall',
  viewImports: 'View imports',
  webinarPopUpTitle: 'WhatsApp Business will have new pricing from June 1, 2023!',
  webinarPopUpSubtitle: 'Join us in this webinar where we will explain these changes in detail.',
  webinarPopUpButton: 'Sign up today',
  seeProgress: 'See progress',
  hide: 'Hide',
  looksLikeTooManyContacts: 'You have an important amount of contacts! 🥳',
  fileTooBigSubtitle: 'Because of the file size, you\'ll need some help from us to import them.',
  askForHelp: 'Ask for help to import',
  iNeedHelpImporting: 'I need help importing contacts',
  couldntMoveStep: 'Couldn\'t move step'
}
